
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.813 5.156h.234c.198 0 .377-.031.539-.093.167-.063.352-.18.555-.352.203-.172.513-.492.93-.961.5-.557.84-.96 1.023-1.21.229-.298.383-.548.46-.75.063-.152.094-.298.094-.438 0-.209-.06-.36-.18-.454C6.35.8 6.186.74 5.978.718V.337h3.406v.383c-.167.036-.33.101-.492.195a2.5 2.5 0 00-.5.375c-.167.156-.414.417-.743.781L5.023 5.023l2.844 4.133c.302.438.54.745.711.922.172.172.336.3.492.383.157.078.323.13.5.156V11H6.125v-.383c.193-.015.333-.052.422-.11a.287.287 0 00.133-.257.804.804 0 00-.094-.336 2.807 2.807 0 00-.281-.484l-1.82-2.711c-.214-.323-.37-.537-.47-.64a.929.929 0 00-.32-.227 1.13 1.13 0 00-.46-.079H2.82v3.274c0 .349.01.604.032.765.026.162.065.29.117.383a.697.697 0 00.242.235c.11.062.284.125.523.187V11H.445v-.383c.323-.083.54-.174.649-.273.11-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.445.72V.336h3.29v.383c-.23.057-.396.114-.5.172a.754.754 0 00-.243.218c-.057.084-.101.211-.133.383a5.85 5.85 0 00-.039.797l-.007 2.867z","fill":"currentColor"}})])
          )
        }
      }
    